// src/config/api.js

// API Base URL - automatycznie wybiera odpowiedni URL
// Ensure the URL always ends with /api
let baseUrl = process.env.REACT_APP_API_URL || 'https://sigma-work-api.onrender.com/api';

// If the URL doesn't end with /api, append it
if (!baseUrl.endsWith('/api')) {
  baseUrl = baseUrl.replace(/\/$/, '') + '/api';
}

export const API_BASE_URL = baseUrl;

// Environment
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';

// Timeout dla requestów (30 sekund)
export const API_TIMEOUT = 30000;

// Czy logować requesty w konsoli (tylko dev)
export const DEBUG_API = ENVIRONMENT === 'development';